import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React from 'react'
import { AuthProvider } from '../context/AuthProvider'
import { SocketProvider } from '../context/SocketProvider'
import { queryClient } from '../lib/queryClient'
import { config } from '../config'

const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const app = (
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<SocketProvider>
					{children}
					<ReactQueryDevtools initialIsOpen={false} />
				</SocketProvider>
			</AuthProvider>
		</QueryClientProvider>
	)
	// Without a client ID Google sign-in can't work, so don't load Google's script on every page.
	return config.googleClientId ? <GoogleOAuthProvider clientId={config.googleClientId}>{app}</GoogleOAuthProvider> : app
}

export default AppProviders
